import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Empty, Modal, Skeleton, Table } from 'antd'

import './../../ui.style.scss'
import { isEmpty } from 'lodash'

class NotificationDetailsModal extends Component {
    state = {
      isLoading: false
    }

    resetState = () => {
      const state = {
        isLoading: false
      }
      this.setState({ ...state })
    }

    render () {
      const {
        isVisible,
        handleCancel,
        title,
        notificationData,
        notificationLoading
      } = this.props

      // Define all columns in a single array
      const columns = [
        {
          title: 'Environment',
          dataIndex: 'environment',
          key: 'environment',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Expires Date',
          dataIndex: 'expiresDate',
          key: 'expiresDate',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Notification Type',
          dataIndex: 'notificationType',
          key: 'notificationType',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Purchase Date',
          dataIndex: 'purchaseDate',
          key: 'purchaseDate',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Original Purchase Date',
          dataIndex: 'originalPurchaseDate',
          key: 'originalPurchaseDate',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Original Transaction Id',
          dataIndex: 'originalTransactionId',
          key: 'originalTransactionId',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Transaction ID',
          dataIndex: 'transactionId',
          key: 'transactionId',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Updated At',
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Pending Renewal Info',
          dataIndex: 'pendingRenewalInfo',
          key: 'pendingRenewalInfo',
          render: (renewalInfo) => {
            if (!renewalInfo || !Array.isArray(renewalInfo) || renewalInfo.length === 0) {
              return '-'
            }
            return (
              <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                {renewalInfo.map((item, index) => (
                  <li key={index} style={{ marginBottom: '8px' }}>
                    <div><strong>Product ID:</strong> {item.product_id || '-'}</div>
                    <div><strong>Auto Renew Product ID:</strong> {item.auto_renew_product_id || '-'}</div>
                    <div><strong>Auto Renew Status:</strong> {item.auto_renew_status || '-'}</div>
                    <div><strong>Original Transaction ID:</strong> {item.original_transaction_id || '-'}</div>
                  </li>
                ))}
              </ul>
            )
          },
          width: 320
        },
        {
          title: 'Auto Renew Product ID',
          dataIndex: ['data', 'auto_renew_product_id'],
          key: 'auto_renew_product_id',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Auto Renew Status',
          dataIndex: ['data', 'auto_renew_status'],
          key: 'auto_renew_status',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Auto Renew Status Change Date',
          dataIndex: ['data', 'auto_renew_status_change_date'],
          key: 'auto_renew_status_change_date',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Auto Renew Status Change Date MS',
          dataIndex: ['data', 'auto_renew_status_change_date_ms'],
          key: 'auto_renew_status_change_date_ms',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'Auto Renew Status Change Date PST',
          dataIndex: ['data', 'auto_renew_status_change_date_pst'],
          key: 'auto_renew_status_change_date_pst',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'BID',
          dataIndex: ['data', 'bid'],
          key: 'bid',
          render: text => text || '-',
          width: 100
        },
        {
          title: 'BVRS',
          dataIndex: ['data', 'bvrs'],
          key: 'bvrs',
          render: text => text || '-',
          width: 100,
          className: 'non-action-table-row'
        }
      ]

      // Prepare data for the table, assuming notificationData is always an array
      const tableData = Array.isArray(notificationData)
        ? notificationData.map((item, index) => ({
          ...item,
          key: item.id || index
        }))
        : []

      return (
        <Modal
          className='general-modal notification-details-modal'
          title={title}
          maskClosable={false}
          visible={isVisible}
          cancelText='Close'
          onOk={() => {}}
          onCancel={handleCancel}
          closable={false}
          centered
          destroyOnClose
          afterClose={this.resetState}
          width='94vw'
        >
          <div>
            {notificationLoading ? (
              <div className='details'>
                <Skeleton active paragraph={{ rows: 5 }} />
              </div>
            ) : isEmpty(notificationData)
              ? <div style={{ marginTop: 100 }}><Empty /></div>
              : (
                <div className='role-user-table'>
                  <Table
                    className='general-table'
                    dataSource={tableData}
                    columns={columns}
                    pagination={tableData.length > 10}
                    // size='middle'
                    bordered
                    scroll={{ x: 1500, y: 'calc(100vh - 400px)' }}
                  />
                </div>
              )}
          </div>
        </Modal>
      )
    }
}

NotificationDetailsModal.propTypes = {
  /** visible file status of CreateCategoryModal. */
  isVisible: PropTypes.bool,
  /** cancel action of CreateCategoryModal. */
  handleCancel: PropTypes.func,
  /** title of the modal */
  title: PropTypes.string,
  /** notification data to display */
  notificationData: PropTypes.array,
  /** loading state for notification data */
  notificationLoading: PropTypes.bool
}

NotificationDetailsModal.defaultProps = {
  title: 'Notification Details',
  notificationLoading: false,
  notificationData: []
}

export default NotificationDetailsModal
